// IndexedDB-backed local store for the offline-first layer.
// Stores:
//  - queue: persistent mutation queue (keyPath operationId). Stores File/Blob directly.
//  - cache: last-known server GET payloads for overlayable lists (keyPath key).
const DB_NAME = "pruefdoc-offline";
const VERSION = 3;

function openDb() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, VERSION);
    req.onupgradeneeded = (event) => {
      const db = req.result;
      const oldV = event.oldVersion || 0;
      // v1 -> v2 migrated the queue keyPath from "id" to "operationId".
      // Only recreate when coming from v1 (or fresh); never wipe an existing v2 queue.
      if (oldV < 2) {
        if (db.objectStoreNames.contains("queue")) db.deleteObjectStore("queue");
        db.createObjectStore("queue", { keyPath: "operationId" });
      } else if (!db.objectStoreNames.contains("queue")) {
        db.createObjectStore("queue", { keyPath: "operationId" });
      }
      if (!db.objectStoreNames.contains("cache")) db.createObjectStore("cache", { keyPath: "key" });
      // v3: durable store for ops the server permanently rejected (shown in "Nicht synchronisiert").
      if (!db.objectStoreNames.contains("failed")) db.createObjectStore("failed", { keyPath: "operationId" });
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

function tx(store, mode, fn) {
  return openDb().then((db) => new Promise((resolve, reject) => {
    const t = db.transaction(store, mode);
    const os = t.objectStore(store);
    const out = fn(os);
    t.oncomplete = () => resolve(out && out.result !== undefined ? out.result : out);
    t.onerror = () => reject(t.error);
    t.onabort = () => reject(t.error);
  }));
}

export const idb = {
  put: (store, value) => tx(store, "readwrite", (os) => os.put(value)),
  get: (store, key) => openDb().then((db) => new Promise((res, rej) => {
    const r = db.transaction(store, "readonly").objectStore(store).get(key);
    r.onsuccess = () => res(r.result); r.onerror = () => rej(r.error);
  })),
  all: (store) => openDb().then((db) => new Promise((res, rej) => {
    const r = db.transaction(store, "readonly").objectStore(store).getAll();
    r.onsuccess = () => res(r.result || []); r.onerror = () => rej(r.error);
  })),
  del: (store, key) => tx(store, "readwrite", (os) => os.delete(key)),
  clear: (store) => tx(store, "readwrite", (os) => os.clear()),
};
